import Axios from '@/Axios'

class BulkUploadService {
    async validateWorkAllocationData(data) {
        return await Axios.post('wms.wms.api.bulk_upload.validate_workallocation_data', { data })
    }

    async uploadFile(formData) {
        return await Axios.post('wms.wms.api.bulk_upload.upload_file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    async importData(formData) {
        return await Axios.post('wms.wms.api.bulk_upload.import_work_allocation_records', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    async createBulkUploadRecord(data) {
        return await Axios.post('wms.wms.api.bulk_upload.create_bulk_upload', data)
    }

    async getBulkUploadRecords(data = {}) {
        return await Axios.get('wms.wms.api.bulk_upload.get_bulk_uploads', { params : data})
    }

    async getBulkUploadRecord(name) {
        return await Axios.get('wms.wms.api.bulk_upload.get_bulk_upload_by_id', { params : {name}})
    }

    async getFileData(data) {
        return await Axios.get('wms.wms.api.bulk_upload.get_file_data', { params : data})
    }
    
}
export default new BulkUploadService()
